// extracted by mini-css-extract-plugin
module.exports = {"Container":"Avatar_Container__tuTU1","Avatar":"Avatar_Avatar__13CXS","ModalAvatar":"Avatar_ModalAvatar__3-CLc","Overlay":"Avatar_Overlay__BmZBR"};